import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TextArea } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import commonPropTypes from '../../../constants/commonPropTypes';
import { formFieldWrapper } from '../formFieldWrapper';
import styles from './styles.scss';
const cx = classnames.bind(styles);
class BaseTextAreaField extends Component {
    static propTypes = {
        ...commonPropTypes,
        normalizeOnBlur: PropTypes.func,
        compact: PropTypes.bool,
    };
    static defaultProps = {
        compact: false,
    };
    render() {
        const { elmId, value, onChange, onBlur, placeholder, label, normalizeOnBlur, showError, className, compact, disabled, ...rest } = this.props;
        const onBlurNew = e => {
            if (normalizeOnBlur) {
                e.target.value = normalizeOnBlur(e.target.value);
            }
            onBlur && onBlur(e);
        };
        const finalValue = _.isNil(value) ? '' : String(value);
        return (_jsx(TextArea, { "data-elm-id": `${elmId}_textarea`, value: finalValue, onChange: onChange, onBlur: onBlurNew, placeholder: placeholder || label, className: cx(className, 'textarea', {
                error: showError,
                disabled,
                compact,
            }), disabled: disabled, ...rest }));
    }
}
export default formFieldWrapper((fieldProps, showError) => (_jsx(BaseTextAreaField, { ...fieldProps, showError: showError })));
//# sourceMappingURL=index.js.map